import { QA_CATEGORY_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const QaCategoryService = {
  getAll: (params: any) => requests.get(`${QA_CATEGORY_URL}`, params),
  create: (params: any) => requests.post(`${QA_CATEGORY_URL}`, params),
  getSingle: (id: number) => requests.get(`${QA_CATEGORY_URL}/${id}`),
  update: (params: any, id: number) => requests.put(`${QA_CATEGORY_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${QA_CATEGORY_URL}/${id}`),
};